import { render } from "./App.vue?vue&type=template&id=858ee71c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=858ee71c&lang=less&scoped=true"

import exportComponent from "C:\\project\\famous-build-en\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-858ee71c"]])

export default __exports__